module.exports = __webpack_public_path__ + "static/media/61.02eb31f3.jpeg";